// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"845":"b0a86b24","966":"73c94a53"}[chunkId] + ".chunk.js";
};